import { ApiAuthorization, ApiDataModel, ApiModule } from '@/api/apiConstants'

const groupPrefix = createApiRoute(ApiModule.AUTH, ApiAuthorization.EMPLOYEE, ApiDataModel.LOCATIONS)

export const apiEmployeeLocation = {
	fetchEmployeeLocations: async (): Promise<IEmployeeLocationModel[]> => {
		const { data } = await apiCommon<IEmployeeLocation[]>(`${groupPrefix}`, { method: 'GET' })

		return data.map(l => EmployeeLocation(l))
	},

	fetchAvailableLocations: async (): Promise<IEmployeeLocationModel[]> => {
		const { data } = await apiCommon<IEmployeeLocation[]>(`${groupPrefix}/all`, { method: 'GET' })

		return data.map(l => EmployeeLocation(l))
	},
}
